import type { Campaign, CampaignFilterStatus } from '../../../../infrastructure/CampaignClient';
import { CampaignStatus } from '../../../../infrastructure/CampaignClient';

export interface CampaignListProps {
  campaigns: Campaign[];
  onView: (campaign: Campaign) => void;
  onEdit: (campaign: Campaign) => void;
  onDelete: (campaign: Campaign) => void;
  onStatusChange: (campaign: Campaign, status: CampaignStatus) => void;
  loading?: boolean;
}

export interface CampaignFiltersProps {
  selectedStatus: CampaignFilterStatus;
  onStatusChange: (status: CampaignFilterStatus) => void;
  totalCampaigns: number;
}

export interface CampaignDetailModalProps {
  show: boolean;
  campaign: Campaign | null;
  onHide: () => void;
  onEdit: () => void;
}

export interface CreateCampaignModalProps {
  show: boolean;
  onHide: () => void;
  onSubmit: (formData: FormData) => void;
  isSubmitting?: boolean;
}

export interface UpdateCampaignModalProps {
  show: boolean;
  campaign: Campaign | null;
  onHide: () => void;
  onSubmit: (formData: FormData) => void;
  isSubmitting?: boolean;
}

export interface DeleteCampaignModalProps {
  show: boolean;
  campaign: Campaign | null;
  onHide: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
}

export interface FormData {
  name: string;
  startAt: Date;
  endAt: Date;
  status: CampaignStatus;
}

export const getCampaignStatusColor = (status: CampaignStatus): string => {
  switch (status) {
    case CampaignStatus.PUBLISHED:
      return 'success';
    case CampaignStatus.DRAFT:
      return 'warning';
    default:
      return 'secondary';
  }
};

export const getCampaignStatusText = (status: CampaignStatus): string => {
  switch (status) {
    case CampaignStatus.PUBLISHED:
      return 'Published';
    case CampaignStatus.DRAFT:
      return 'Draft';
    default:
      return 'Unknown';
  }
};
